import Vue from 'vue'
import FilterFieldModalComponent from './index.vue'

// 创建FilterFieldModal构造函数
const FilterFieldModalConstructor = Vue.extend(FilterFieldModalComponent)

let instance
let seed = 1

// 关闭弹窗时销毁
const destroyInstance = () => {
  if (instance) {
    instance.$destroy()
    instance.$el.remove()
    instance = null
  }
}

// 创建实例
const FilterFieldModal = function (options = {}) {
  if (Vue.prototype.$isServer) return
  destroyInstance()
  // 如果已有实例且正在显示，先关闭
  if (!instance) {
    instance = new FilterFieldModalConstructor({})
    const id = 'select_modal_' + seed++
    instance.id = id
    instance.$mount()
    document.body.appendChild(instance.$el)
  }

  return instance.show(options)
}

// 插件安装函数
FilterFieldModal.install = function (Vue) {
  Vue.prototype.$filterFieldModal = FilterFieldModal
}

export default FilterFieldModal
